export default "__VITE_ASSET__CaCfQK3a__"